import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import AdsCard from '../AdsCard';
import { CommonModal } from '../../../CommonModal';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UPDATE_USER_DATA } from '../../../../redux/features/user/userSlice';
import { fetchCredentials,getGoogleAnalyticsAccounts } from '../../../../services/ApiService';
import { getOAuthRedirectUri } from '../../../../utils/oauthRedirect';
import GoogleAnalyticsAdAccountTable from './GoogleAnalyticsAdAccountTable';
import googleAnalytics from "../../../../assests/google-analytics.svg"



const GoogleAnalyticsIntegration = ({isAccountLinked,fetchAdsAccountStatus,accountDetails,social_media_type}) => {
const [authCode, setAuthCode] = useState("");
const [apiData, setApiData] = useState([]);
const [connecting, setConnecting] = useState(false);
const [customerAccounts, setCustomerAccounts] = useState([]);
const [showAdsAccountsModal, setShowAdsAccountsModal] = useState(false);

const dispatch=useDispatch()

  const handleConnect = async () => {
    setConnecting(true);
    localStorage.setItem('selected_platform_to_connect', 'google_analytics');
    localStorage.removeItem('google_analytics_code');

    const credentials = await fetchCredentials();

    if (credentials?.google?.google_ads_client_id) {
      dispatch(
        UPDATE_USER_DATA({
          CLIENT_ID: credentials.google.google_ads_client_id,
          CLIENT_SECRET: credentials?.google?.google_ads_client_secret,
          DEVELOPER_TOKEN: credentials?.google?.google_ads_developer_token,
        })
      );

      const redirectUri = encodeURIComponent(
        credentials?.google?.google_analytics_redirect_uri || getOAuthRedirectUri(),
      );
      const API_URL1 = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${credentials.google.google_ads_client_id}&redirect_uri=${redirectUri}&response_type=code&scope=https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/analytics.readonly&access_type=offline&prompt=consent`;
      window.location.href = API_URL1;
      return;
    }

    setConnecting(false);
    toast.error('Error connecting to Google Analytics');
  };

   const handleGoogleAnalyticsAccounts=async ()=>{
    try{
        let result=await getGoogleAnalyticsAccounts(authCode)
       // console.log(result)
        if(result?.success)
        {
          if(result?.data?.accounts?.length>0)
          {
            setCustomerAccounts(result?.data?.accounts)
            setShowAdsAccountsModal(true)
          }
           

        }

    }catch(e)
    {
        console.log(e)
    }

   }
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
  
      if (code && localStorage.getItem('selected_platform_to_connect')==='google_analytics') {
        setAuthCode(code);
      }
    }, []);

    useEffect(()=>{
      if(authCode!="")
      {
        handleGoogleAnalyticsAccounts()
      }


    },[authCode])


  return (
    <>
    <AdsCard
       fetchAdsAccountStatus={fetchAdsAccountStatus}
        handleConnect={handleConnect}
        isAccountLinked={isAccountLinked}
        platform={"Google Analytics"}
        platform_icon={googleAnalytics}
        connecting={connecting}
        description="Google Ads is Google's online advertising platform that enables businesses to create and manage targeted advertising campaigns across various Google services."
        accountDetails={accountDetails}
        social_media_type={social_media_type}
        
      />

          {connecting ? null : (
              <CommonModal
                title={
                  <>
                    <div className="d-flex flex-column gap-1">
                      <span className="fs-4 fw-bold">Your Google Analytics Accounts</span>
                      <small className="fs-8">Select an account to proceed with integration.</small>
                    </div>
                  </>
                }
                body={
                  // customerAccounts.length > 0 && (
                    <GoogleAnalyticsAdAccountTable
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      customerAccounts={customerAccounts}
                      setShowAdsAccountsModal={setShowAdsAccountsModal}
                    />
                  //)
                }
                show={showAdsAccountsModal}
                setShow={setShowAdsAccountsModal}
              />
            )}
           
    </>
  )
}

export default GoogleAnalyticsIntegration